import { v4 as uuid } from 'uuid';
import { ClientsService } from '../../clients/clients.service';

export function correlationIdInitializer(clientsService: ClientsService): () => Promise<boolean> {
    return (): Promise<boolean> => {
        return new Promise<boolean>((resolve, reject) => {
            try {
                clientsService.saveCorrelationId(uuid());
                resolve(true);
            } catch (e) {
                reject(e);
            }
        });
    };
}
